/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  RunScriptResult,
  DeployContractExecutionResult,
  NetworkId,
} from "@alephium/web3";
import {
  AlphUnstakeVault,
  AlphUnstakeVaultInstance,
  XAlphToken,
  XAlphTokenInstance,
  GovernanceDemo,
  GovernanceDemoInstance,
  RewardSharingVault,
  RewardSharingVaultInstance,
  XAlphStakeVault,
  XAlphStakeVaultInstance,
} from ".";
import { default as testnetDeployments } from "../../deployments/.deployments.testnet.json";
import { default as devnetDeployments } from "../../deployments/.deployments.devnet.json";

export type Deployments = {
  deployerAddress: string;
  contracts: {
    AlphUnstakeVault: DeployContractExecutionResult<AlphUnstakeVaultInstance>;
    XAlphToken: DeployContractExecutionResult<XAlphTokenInstance>;
    GovernanceDemo: DeployContractExecutionResult<GovernanceDemoInstance>;
    RewardSharingVault: DeployContractExecutionResult<RewardSharingVaultInstance>;
    XAlphStakeVault: DeployContractExecutionResult<XAlphStakeVaultInstance>;
  };
};

function toDeployments(json: any): Deployments {
  const contracts = {
    AlphUnstakeVault: {
      ...json.contracts["AlphUnstakeVault"],
      contractInstance: AlphUnstakeVault.at(
        json.contracts["AlphUnstakeVault"].contractInstance.address
      ),
    },
    XAlphToken: {
      ...json.contracts["XAlphToken"],
      contractInstance: XAlphToken.at(
        json.contracts["XAlphToken"].contractInstance.address
      ),
    },
    GovernanceDemo: {
      ...json.contracts["GovernanceDemo"],
      contractInstance: GovernanceDemo.at(
        json.contracts["GovernanceDemo"].contractInstance.address
      ),
    },
    RewardSharingVault: {
      ...json.contracts["RewardSharingVault"],
      contractInstance: RewardSharingVault.at(
        json.contracts["RewardSharingVault"].contractInstance.address
      ),
    },
    XAlphStakeVault: {
      ...json.contracts["XAlphStakeVault"],
      contractInstance: XAlphStakeVault.at(
        json.contracts["XAlphStakeVault"].contractInstance.address
      ),
    },
  };
  return {
    ...json,
    contracts: contracts as Deployments["contracts"],
  };
}

export function loadDeployments(
  networkId: NetworkId,
  deployerAddress?: string
): Deployments {
  const deployments =
    networkId === "testnet"
      ? testnetDeployments
      : networkId === "devnet"
      ? devnetDeployments
      : undefined;
  if (deployments === undefined) {
    throw Error("The contract has not been deployed to the " + networkId);
  }
  const allDeployments: any[] = Array.isArray(deployments)
    ? deployments
    : [deployments];
  if (deployerAddress === undefined) {
    if (allDeployments.length > 1) {
      throw Error(
        "The contract has been deployed multiple times on " +
          networkId +
          ", please specify the deployer address"
      );
    } else {
      return toDeployments(allDeployments[0]);
    }
  }
  const result = allDeployments.find(
    (d) => d.deployerAddress === deployerAddress
  );
  if (result === undefined) {
    throw Error("The contract deployment result does not exist");
  }
  return toDeployments(result);
}
